// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* tslint:disable */
/* eslint-disable */
import "../textstyles/fonts.css";
import "../reset.css";
import "./CardSegmented.Button.css";
import React, { createContext, useContext } from "react";
import {
  exists,
  findSetVariantProps,
  makeCompositeDefaultProps,
} from "../_internal_utils";
import { SpacerPrimitive, TextPrimitive } from "../_internal_primitives";
import { RadioGroupButtonRoot } from "../_internal_radio_group";

const styles = [
  {
    type: "default",
    layers: {
      "segmented-control-button-text": {
        none: {
          text: "The description of the option",
        },
      },
      E3QEuz2fEE: {
        none: {
          text: "Option Title",
        },
      },
    },
  },
  {
    type: "boolean",
    propName: "selected",
    layers: {},
  },
];

const defaultPropValues = [
  {
    type: "default",
    layers: {},
  },
  {
    type: "boolean",
    propName: "selected",
    layers: {},
  },
];

const variantPropTypes = [
  {
    type: "boolean",
    propName: "selected",
  },
];

export const ButtonContext = createContext(null);

function Button(_props) {
  const defaults = useContext(ButtonContext);
  const props = { ...defaults, ..._props };
  const activeVariants = findSetVariantProps(variantPropTypes, props);
  const getCompositeDefaultProps = makeCompositeDefaultProps(
    defaultPropValues,
    activeVariants
  );
  return (
    <RadioGroupButtonRoot
      {...props}
      key="segmented-control-button-root"
      addSpacing={false}
      internal={{
        projectId: "7X7HTLRqyD",
        styles: styles,
        layerId: "segmented-control-button-root",
        scope: "Qq5tfjVMEQ",
        activeVariants: activeVariants,
      }}
    >
      {(getStyle) => (
        <>
          <TextPrimitive
            id={"title_E3QEuz2fEE"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_Qq5tfjVMEQ_E3QEuz2fEE"
            }
            key={"E3QEuz2fEE"}
            text={
              exists(props.title) ? props.title : getStyle("E3QEuz2fEE", "text")
            }
            element={getStyle("E3QEuz2fEE", "htmlElement")}
          />
          <SpacerPrimitive
            id={"Spacer_NJeuc44DJB"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_Qq5tfjVMEQ_NJeuc44DJB"
            }
            key={"NJeuc44DJB"}
          />
          <TextPrimitive
            id={"subtitle_segmented-control-button-text"}
            className={
              "__visly_reset_7X7HTLRqyD __visly_scope_Qq5tfjVMEQ_segmented-control-button-text"
            }
            key={"segmented-control-button-text"}
            text={
              exists(props.subtitle)
                ? props.subtitle
                : getStyle("segmented-control-button-text", "text")
            }
            element={getStyle("segmented-control-button-text", "htmlElement")}
          />
        </>
      )}
    </RadioGroupButtonRoot>
  );
}

Button.__variants = [
  {
    name: "selected",
    type: "variant",
  },
];

export default Button;
